<template>
  <div class="component-sale-address-confirmation text-center">
    <span>Deseja exportar o arquivo com o endereço do comprador?</span>
    <div class="d-flex justify-content-center my-9">
      <b-form-radio-group v-model="exportAddress">
        <b-form-radio value="no">Não</b-form-radio>
        <b-form-radio value="yes">Sim</b-form-radio>
      </b-form-radio-group>
    </div>
    <div class="row">
      <div class="col-lg-6 order-lg-2 mb-5 mb-lg-0 pl-lg-3">
        <button class="btn btn-primary btn-block" @click="confirm">
          Confirmar
        </button>
      </div>
      <div class="col-lg-6 order-lg-1 pr-lg-3">
        <button class="btn btn-new-secondary btn-block" @click="$emit('close')">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      exportAddress: "no"
    };
  },
  methods: {
    confirm() {
      this.$emit("confirm", this.exportAddress === "yes");
      this.$emit("close");
    }
  }
};
</script>
